import React, { useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo.jpeg';


const AdminHeader = () => {

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    const handleLinkClick = () => {
        setIsCollapsed(true); // Collapse the navbar after link click
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) { // Change 50 to the scroll position you want
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const handleLogout = () => {
        localStorage.removeItem('user');
        navigate('/');
        window.location.reload();
    }

    return (
        <>
            <nav className={`navbar navbar-expand-lg sticky-top ${isScrolled ? 'bg-white shadow-sm' : ''}`}>
                <div className="container">
                    <Link className="navbar-brand py-0" to='/'><img src={Logo} className='img-fluid' alt='Site Logo' style={{height: '3.5em'}} /></Link>
                    <button className="navbar-toggler" onClick={() => setIsCollapsed(!isCollapsed)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i class="fa-solid fa-bars"></i>
                    </button>
                    <div className={`collapse navbar-collapse justify-content-center ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/admin/dashboard'>Dashboard</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/admin/clients'>Clients</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/admin/reports'>Daily Reports</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/admin/blogs'>Blogs</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/admin/reward-history'>Rewards History</NavLink>
                            </li>
                            <li className="nav-item my-2">
                                <button className="admin-btn py-2 px-3" activeClassName="active" onClick={handleLogout}>Logout&nbsp; <i className="fa-solid fa-right-from-bracket"></i></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default AdminHeader
